const handleDeleteEmployeeMyComp = {
  confirm: '¿Realmente desea eliminar este colaborador?',
  title: 'ELIMINAR COLABORADOR'
};

export default handleDeleteEmployeeMyComp;
